import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: FilterState = {
    searchTerm: '',
    showSystemActions: true,
    authorAndOr: 'and',
    authorIds: [],
    actionTypeIds: [],
    actionTypeAndOr: 'and',
    searchTermOption: 'Include',
    dateRange: null,
    customStartDate: null,
    customEndDate: null,
    hasReactions: false
} as FilterState;

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setFilter(state, action: PayloadAction<FilterState>) {
            state = action.payload;
        },
        setSearchTerm(state, action: PayloadAction<string>) {
            state.searchTerm = action.payload;
        },
        setSearchTermOption(state, action: PayloadAction<termOptions>) {
            state.searchTermOption = action.payload;
        },
        setAuthorAndOr(state, action: PayloadAction<'and' | 'or'>) {
            state.authorAndOr = action.payload;
        },
        setAuthors(state, action: PayloadAction<number[]>) {
            state.authorIds = action.payload;
        },
        setActionTypes(state, action: PayloadAction<number[]>) {
            state.actionTypeIds = action.payload;
        },
        setActionTypeAndOr(state, action: PayloadAction<'and' | 'or'>) {
            state.actionTypeAndOr = action.payload;
        },
        setDateRange(state, action: PayloadAction<dateRangeOptions>) {
            state.dateRange = action.payload;
        },
        setStartDate(state, action: PayloadAction<Date>) {
            state.customStartDate = action.payload;
        },
        setEndDate(state, action: PayloadAction<Date>) {
            state.customEndDate = action.payload;
        },
        setShowSystemActions(state, action: PayloadAction<boolean>) {
            state.showSystemActions = action.payload;
        },
        setHasReaction(state, action: PayloadAction<boolean>) {
            state.hasReactions = action.payload;
        },
        resetFilters(state) {
            //Reset each key to its initial state
            Object.keys(initialState).forEach(key => {
                state[key] = initialState[key];
            });
        },
    },
});

export const { setSearchTerm, setAuthors, setActionTypes, setDateRange, setStartDate, setEndDate, setShowSystemActions, setHasReaction, resetFilters, setAuthorAndOr, setActionTypeAndOr, setSearchTermOption } = filterSlice.actions;

export default filterSlice.reducer;
